import { api } from "./api"

type DownloadResponse = {
  download_url: string
  downloads_count: number
}

export const downloads = {
  track: (sampleId: number) =>
    api.post<DownloadResponse>(`/samples/${sampleId}/download`),
}
